/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import style from './Icons.scss';

export const Tick = ({ className }) => (
  <svg
    className={cx(style.iconSVG, className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.753 0.231589C16.0595 0.531393 16.0842 1.02241 15.8079 1.35191C12.0117 5.89826 9.35365 9.19237 6.14548 15.5515C6.00461 15.8328 5.71739 16.0063 5.4073 15.9998C5.0963 15.9924 4.8173 15.8058 4.68832 15.519C3.50556 12.9005 2.03749 10.4243 0.312103 8.13623C-0.147086 7.54681 -0.0940454 6.7003 0.434679 6.17402C0.964307 5.64867 1.79946 5.61246 2.37117 6.09141C3.41855 6.97785 4.41835 7.92274 5.36319 8.92145C5.36319 8.92145 9.99442 3.16942 14.7566 0.126714C15.0731 -0.0756321 15.485 -0.0320196 15.753 0.231589Z"
      fill="#8FCECE"
    />
  </svg>
);

export const Cross = ({ className }) => (
  <svg
    className={cx(style.iconSVG, className)}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.86209 5.60109C4.61351 2.42613 2.00678 -0.145736 1.46514 0.549631C0.936847 1.22752 2.52853 4.8223 5.42676 8.16523C1.85199 12.0678 -0.401539 15.224 0.0596435 15.8569C0.533083 16.5052 3.71761 14.3083 7.74568 10.6808C11.3194 14.3222 14.5532 16.6095 15.1404 15.8569C15.7047 15.1339 13.6184 11.8423 10.3724 8.22414C10.6238 7.98003 10.8766 7.73436 11.1307 7.48403C16.6437 2.03733 16.274 1.37078 15.6738 0.549631C15.0733 -0.271316 14.4679 -0.936989 8.95489 4.50952C8.58177 4.87491 8.21786 5.2388 7.86209 5.60109Z"
      fill="#F29A88"
    />
  </svg>
);

export const Dash = () => (
  <svg
    className={style.iconSVG}
    width="18"
    height="4"
    viewBox="0 0 18 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2H16"
      stroke="#5D717C"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLineJoin="round"
    />
  </svg>
);

export const RowExpansionArrow = ({ expanded }) => {
  return expanded ? (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.28 6.53C11.14 6.67 10.94 6.75 10.75 6.75C10.56 6.75 10.37 6.68 10.22 6.53L6 2.31L1.78 6.53C1.64 6.67 1.44 6.75 1.25 6.75C1.06 6.75 0.86 6.68 0.72 6.53C0.58 6.38 0.5 6.19 0.5 6C0.5 5.81 0.58 5.61 0.72 5.47L5.47 0.72C5.62 0.570001 5.81 0.5 6 0.5C6.19 0.5 6.38 0.58 6.53 0.72L6.56 0.75L11.28 5.47C11.43 5.61 11.5 5.81 11.5 6C11.5 6.19 11.43 6.38 11.28 6.53Z"
        fill="#9BABB3"
      />
    </svg>
  ) : (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.28 0.469999C11.14 0.329999 10.94 0.25 10.75 0.25C10.56 0.25 10.37 0.319999 10.22 0.469999L6 4.69L1.78 0.469999C1.64 0.329999 1.44 0.25 1.25 0.25C1.06 0.25 0.86 0.319999 0.72 0.469999C0.58 0.62 0.5 0.81 0.5 1C0.5 1.19 0.58 1.39 0.72 1.53L5.47 6.28C5.62 6.43 5.81 6.5 6 6.5C6.19 6.5 6.38 6.42 6.53 6.28L6.56 6.25L11.28 1.53C11.43 1.39 11.5 1.19 11.5 1C11.5 0.81 11.43 0.62 11.28 0.469999Z"
        fill="#9BABB3"
      />
    </svg>
  );
};
